import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogArticle from "../pages/blog/pandabuy-spreadsheet-comparison-guide/page";
import BlogPage from "../pages/blog/BlogPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/pandabuy-spreadsheet-comparison-guide",
    element: <BlogArticle />,
  },
  {
    path: "/blog/:slug",
    element: <BlogPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;